import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

const SMALL_SIZE_WIDTH_PCT = 0.06;
const LARGE_SIZE_WIDTH_PCT = 0.13;

const CardWrapper = styled.div`
    margin: 0 1rem 0.65rem 1.0rem;
    cursor: pointer;
    display: block;
    float: none;
`;

const CardWrapperHalfSize = styled.div`
    margin: 0 0.5rem 0.65rem 0.5rem;
    cursor: pointer;
    display: inline-block;
    float: none;
    vertical-align: top;
`;

const ImageWrapper = styled.img`
    border-radius: 0.25rem;
`;

const ImageWrapperHalfSize = styled.img`
    border-radius: 0.125rem;
`;

const ImageText = styled.div`
    display: inline-block;
    font-size: 0.95rem;
    color: #666666;
    letter-spacing: 0.1rem;
`;

const ImageTextYear = styled.div`
    display: inline-block;
    font-size: 0.65rem;
    color: #666666;
    letter-spacing: 0.065rem;
    margin-left: 0.25rem;
    font-style: italic;
`;

const ImageTextHalfSize = styled.div`
    display: inline-block;
    font-size: 0.75rem;
    color: #666666;
    letter-spacing: 0.05rem;
`;

const ImageTextHalfSizeYear = styled.div`
    display: inline-block;
    font-size: 0.5rem;
    color: #666666;
    letter-spacing: 0.04rem;
    margin-left: 0.15rem;
    font-style: italic;
`;

export class VideoUpNextCard extends Component {

    static propTypes = {
        video_item: PropTypes.object.isRequired,
        on_click: PropTypes.func.isRequired,
        half_size: PropTypes.bool.isRequired,
    }

    state = {
        innerWidth: window.innerWidth
    };

    handleResize = (e) => {
        this.setState({innerWidth: window.innerWidth});
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    render() {
        const {video_item, half_size, on_click} = this.props;
        const width_style = !this.props.half_size ?
            {width: this.state.innerWidth * LARGE_SIZE_WIDTH_PCT} :
            {width: this.state.innerWidth * SMALL_SIZE_WIDTH_PCT};
        const image = !half_size ?
            <ImageWrapper style={width_style} src={video_item.items.thumbnail_url.value}/> :
            <ImageWrapperHalfSize style={width_style} src={video_item.items.thumbnail_url.value}/>;
        const image_text = !half_size ?
            <ImageText style={width_style}>
                {video_item.items.title.value}
                <ImageTextYear>({video_item.items.year.value})</ImageTextYear>
            </ImageText> :
            <ImageTextHalfSize style={width_style}>
                {video_item.items.title.value}
                <ImageTextHalfSizeYear>({video_item.items.year.value})</ImageTextHalfSizeYear>
            </ImageTextHalfSize>;
        return !half_size ?
            <CardWrapper style={width_style} onClick={e => on_click()} title={"click to view"}>
                {image}
                {image_text}
            </CardWrapper> :
            <CardWrapperHalfSize style={width_style} onClick={e => on_click()} title={"click to view"}>
                {image}
                {image_text}
            </CardWrapperHalfSize>
    }
}

export default VideoUpNextCard;
